import {Component} from '@angular/core';

@Component({
    selector: 'app-trip-layout',
    templateUrl: './trip-layout.component.html',
    standalone: false
})
export class TripLayoutComponent {

}
